import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit'
import { State } from '../../types/StateType'
import { PatientSmsLogsType } from './types'

const patientSmsLogsAdapter = createEntityAdapter<PatientSmsLogsType>({
  selectId: (smsLog) => smsLog.key,
})

let definedProps: { error: any; loading: boolean; success: any } = {
  error: null,
  loading: false,
  success: null,
}

const initialState = patientSmsLogsAdapter.getInitialState(definedProps)

const patientSmsLogsSlice = createSlice({
  name: 'patientSmsLogs',
  initialState: initialState,
  reducers: {
    getPatientSmsLogs: (state, action: PayloadAction<string>) => {
      state.loading = true
    },
    addPatientSmsLogs: (state, action: PayloadAction<PatientSmsLogsType>) => {
      state.loading = false
      patientSmsLogsAdapter.upsertOne(state, action.payload)
    },
    sendPatientSms: (
      state,
      action: PayloadAction<{
        patientKey: string
        smsMsg: string
      }>
    ) => {},
    errorPatientSmsLogs: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
    successPatientSmsLogs: (state, action: PayloadAction<string | null>) => {
      state.success = action.payload
    },
  },
})

export const {
  addPatientSmsLogs,
  errorPatientSmsLogs,
  getPatientSmsLogs,
  sendPatientSms,
  successPatientSmsLogs,
} = patientSmsLogsSlice.actions

export default patientSmsLogsSlice.reducer

const { selectById } = patientSmsLogsAdapter.getSelectors()

export const selectAllPatientSmsLogs = createSelector(
  (state: State) => state.patientSmsLogsState,
  (patientSmsLogs) => Object.values(patientSmsLogs['entities'])
)

export const selectPatientSmsLogsById = (id: string) =>
  createSelector(
    (state: State) => state.patientSmsLogsState,
    (patientSmsLogs) => selectById(patientSmsLogs, id)?.smsLogs
  )
export const selectSingleAlertFromPatientSmsLogsById = (
  id: string,
  smsId: string
) =>
  createSelector(
    (state: State) => state.patientSmsLogsState,
    (patientSmsLogs) =>
      selectById(patientSmsLogs, id)?.smsLogs.find((sms) => sms.smsId === smsId)
  )

export const selectErrorInPatientSmsLogs = createSelector(
  (state: State) => state.patientSmsLogsState.error,
  (error) => error
)
export const selectSuccessInPatientSmsLogs = createSelector(
  (state: State) => state.patientSmsLogsState.success,
  (success) => success
)
